/**
 * @function setRegexLength
 * This function allows you set length of a specific Regexp. It is used in the field validations
 * @param max
 * @param min
 * @returns Regexp with a specific length
 */
export const setRegexLength = (max: number, min?: number) => {
  if (!min) {
    return new RegExp('^.{' + 0 + ',' + max + '}$') // eslint-disable-line prefer-template
  }
  return new RegExp('^.{' + min + ',' + max + '}$') // eslint-disable-line prefer-template
}

/**
 * @function sentenceCase
 * This function helps you convert text to lowercase or uppercase
 * @param input
 * @param lowercaseBefore
 * @returns Text with new format
 */
export function sentenceCase(input: string, lowercaseBefore: boolean) {
  let text = input === undefined || input === null ? '' : input
  if (lowercaseBefore) {
    text = text.toLowerCase()
  }
  return text.toString().replace(/(^|\. *)([a-z])/g, function(match) {
    return match.toUpperCase()
  })
}
